// <auto-generated>
// This file is automatically generated by the Nexo CLI.
// Do not modify this file directly. Changes will be overwritten.
// Source: CLI error-codes-frontend generator
// Generated: 2026-04-29T13:20:44.641Z
// </auto-generated>

/** All error codes organized by Module > Entity > Code */
export const ErrorCodes = {
  Finance: {
    Account: {
      NotFound: 'Nexo:Finance:Account:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:Account:ConcurrencyConflict',
      DuplicateAccountNumber: 'Nexo:Finance:Account:DuplicateAccountNumber',
    },
    AccountDerivationRule: {
      NotFound: 'Nexo:Finance:AccountDerivationRule:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:AccountDerivationRule:ConcurrencyConflict',
    },
    AccountDimensionRule: {
      NotFound: 'Nexo:Finance:AccountDimensionRule:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:AccountDimensionRule:ConcurrencyConflict',
    },
    AccountGroup: {
      NotFound: 'Nexo:Finance:AccountGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:AccountGroup:ConcurrencyConflict',
    },
    DimensionDefinition: {
      NotFound: 'Nexo:Finance:DimensionDefinition:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DimensionDefinition:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Finance:DimensionDefinition:DuplicateCode',
      DuplicateName: 'Nexo:Finance:DimensionDefinition:DuplicateName',
    },
    DimensionSet: {
      NotFound: 'Nexo:Finance:DimensionSet:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DimensionSet:ConcurrencyConflict',
      DuplicateHash: 'Nexo:Finance:DimensionSet:DuplicateHash',
    },
    DimensionValue: {
      NotFound: 'Nexo:Finance:DimensionValue:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DimensionValue:ConcurrencyConflict',
      InUseCannotDelete: 'Nexo:Finance:DimensionValue:InUseCannotDelete',
    },
    DistributionProfile: {
      NotFound: 'Nexo:Finance:DistributionProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:DistributionProfile:ConcurrencyConflict',
    },
    FiscalPeriod: {
      InvalidStateTransition: 'Nexo:Finance:FiscalPeriod:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Finance:FiscalPeriod:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Finance:FiscalPeriod:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Finance:FiscalPeriod:RuleExecutionFailed',
      NotFound: 'Nexo:Finance:FiscalPeriod:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:FiscalPeriod:ConcurrencyConflict',
    },
    FiscalYear: {
      NotFound: 'Nexo:Finance:FiscalYear:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:FiscalYear:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Finance:FiscalYear:DuplicateCode',
    },
    PlanHeader: {
      InvalidStateTransition: 'Nexo:Finance:PlanHeader:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Finance:PlanHeader:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Finance:PlanHeader:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Finance:PlanHeader:RuleExecutionFailed',
      NotFound: 'Nexo:Finance:PlanHeader:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanHeader:ConcurrencyConflict',
      ScopePinCollidesWithRowAxis: 'Nexo:Finance:PlanHeader:ScopePinCollidesWithRowAxis',
      SubmitBlockedByEmptyHeader: 'Nexo:Finance:PlanHeader:SubmitBlockedByEmptyHeader',
      ReevaluateRequiresEditableStatus: 'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableStatus',
      ReevaluateRequiresEditableVersion: 'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableVersion',
      ReevaluateAlreadyRunning: 'Nexo:Finance:PlanHeader:ReevaluateAlreadyRunning',
      ReevaluateNothingEligible: 'Nexo:Finance:PlanHeader:ReevaluateNothingEligible',
      EntryBlockedWhileReevaluating: 'Nexo:Finance:PlanHeader:EntryBlockedWhileReevaluating',
      ReevaluateSelectionContested: 'Nexo:Finance:PlanHeader:ReevaluateSelectionContested',
    },
    PlanLine: {
      NotFound: 'Nexo:Finance:PlanLine:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanLine:ConcurrencyConflict',
    },
    PlanLineReevaluationRun: {
      NotFound: 'Nexo:Finance:PlanLineReevaluationRun:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanLineReevaluationRun:ConcurrencyConflict',
      SystemProduced: 'Nexo:Finance:PlanLineReevaluationRun:SystemProduced',
      DuplicateRunNumber: 'Nexo:Finance:PlanLineReevaluationRun:DuplicateRunNumber',
    },
    PlanScenario: {
      NotFound: 'Nexo:Finance:PlanScenario:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanScenario:ConcurrencyConflict',
      ScenarioCodeConflict: 'Nexo:Finance:PlanScenario:ScenarioCodeConflict',
      SourceScenarioHasNoVersions: 'Nexo:Finance:PlanScenario:SourceScenarioHasNoVersions',
      SourceVersionNotInScenario: 'Nexo:Finance:PlanScenario:SourceVersionNotInScenario',
      InvalidScenarioType: 'Nexo:Finance:PlanScenario:InvalidScenarioType',
      TargetFiscalYearNotFound: 'Nexo:Finance:PlanScenario:TargetFiscalYearNotFound',
    },
    PlanStatementTemplate: {
      NotFound: 'Nexo:Finance:PlanStatementTemplate:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanStatementTemplate:ConcurrencyConflict',
    },
    PlanVersion: {
      InvalidStateTransition: 'Nexo:Finance:PlanVersion:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Finance:PlanVersion:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Finance:PlanVersion:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Finance:PlanVersion:RuleExecutionFailed',
      NotFound: 'Nexo:Finance:PlanVersion:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanVersion:ConcurrencyConflict',
      BudgetPublishRequiresApprovedState: 'Nexo:Finance:PlanVersion:BudgetPublishRequiresApprovedState',
      WhatIfCannotBePublished: 'Nexo:Finance:PlanVersion:WhatIfCannotBePublished',
      PublishBlockedByLockedVersion: 'Nexo:Finance:PlanVersion:PublishBlockedByLockedVersion',
      VersionNumberConflict: 'Nexo:Finance:PlanVersion:VersionNumberConflict',
      PublishRequiresLines: 'Nexo:Finance:PlanVersion:PublishRequiresLines',
      PublishBlockedByPendingLines: 'Nexo:Finance:PlanVersion:PublishBlockedByPendingLines',
      PublishAlreadyInProgress: 'Nexo:Finance:PlanVersion:PublishAlreadyInProgress',
      PublishBlockedByReevaluation: 'Nexo:Finance:PlanVersion:PublishBlockedByReevaluation',
      PublishBlockedByMissingReference: 'Nexo:Finance:PlanVersion:PublishBlockedByMissingReference',
      SubmitBlockedByUnsubmittedHeaders: 'Nexo:Finance:PlanVersion:SubmitBlockedByUnsubmittedHeaders',
      ApprovalPending: 'Nexo:Finance:PlanVersion:ApprovalPending',
      SubmitRequiresBudgetScenario: 'Nexo:Finance:PlanVersion:SubmitRequiresBudgetScenario',
    },
    PlanVersionPublishRun: {
      NotFound: 'Nexo:Finance:PlanVersionPublishRun:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanVersionPublishRun:ConcurrencyConflict',
    },
    PlanView: {
      NotFound: 'Nexo:Finance:PlanView:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:PlanView:ConcurrencyConflict',
      MeasureFormulaRequiresDerivedKind: 'Nexo:Finance:PlanView:MeasureFormulaRequiresDerivedKind',
      MeasureFormulaCycle: 'Nexo:Finance:PlanView:MeasureFormulaCycle',
      StorageBindingNotValidForKind: 'Nexo:Finance:PlanView:StorageBindingNotValidForKind',
    },
    VatCode: {
      NotFound: 'Nexo:Finance:VatCode:NotFound',
      ConcurrencyConflict: 'Nexo:Finance:VatCode:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Finance:VatCode:DuplicateCode',
    },
  },
  Procurement: {
    Agreement: {
      InvalidStateTransition: 'Nexo:Procurement:Agreement:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Procurement:Agreement:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Procurement:Agreement:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Procurement:Agreement:RuleExecutionFailed',
      NotFound: 'Nexo:Procurement:Agreement:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:Agreement:ConcurrencyConflict',
      DuplicateAgreementNumber: 'Nexo:Procurement:Agreement:DuplicateAgreementNumber',
    },
    InboundMeasuringTicket: {
      NotFound: 'Nexo:Procurement:InboundMeasuringTicket:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:InboundMeasuringTicket:ConcurrencyConflict',
      AlreadyReceived: 'Nexo:Procurement:InboundMeasuringTicket:AlreadyReceived',
    },
    LoadObservation: {
      NotFound: 'Nexo:Procurement:LoadObservation:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:LoadObservation:ConcurrencyConflict',
    },
    Organization: {
      NotFound: 'Nexo:Procurement:Organization:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:Organization:ConcurrencyConflict',
      DuplicateOrganizationCode: 'Nexo:Procurement:Organization:DuplicateOrganizationCode',
    },
    Project: {
      NotFound: 'Nexo:Procurement:Project:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:Project:ConcurrencyConflict',
      DuplicateProjectId: 'Nexo:Procurement:Project:DuplicateProjectId',
    },
    Supplier: {
      NotFound: 'Nexo:Procurement:Supplier:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:Supplier:ConcurrencyConflict',
      MultiplePrimaryBankAccounts: 'Nexo:Procurement:Supplier:MultiplePrimaryBankAccounts',
      DuplicateSupplierNumber: 'Nexo:Procurement:Supplier:DuplicateSupplierNumber',
    },
    Workorder: {
      NotFound: 'Nexo:Procurement:Workorder:NotFound',
      ConcurrencyConflict: 'Nexo:Procurement:Workorder:ConcurrencyConflict',
      DuplicateWorkorderNumber: 'Nexo:Procurement:Workorder:DuplicateWorkorderNumber',
      DuplicateDeliverySourceId: 'Nexo:Procurement:Workorder:DuplicateDeliverySourceId',
    },
  },
  Workflow: {
    ApprovalDelegation: {
      NotFound: 'Nexo:Workflow:ApprovalDelegation:NotFound',
      ConcurrencyConflict: 'Nexo:Workflow:ApprovalDelegation:ConcurrencyConflict',
    },
    ApprovalPolicy: {
      NotFound: 'Nexo:Workflow:ApprovalPolicy:NotFound',
      ConcurrencyConflict: 'Nexo:Workflow:ApprovalPolicy:ConcurrencyConflict',
      PolicyHasNoSteps: 'Nexo:Workflow:ApprovalPolicy:PolicyHasNoSteps',
      NoApproversResolved: 'Nexo:Workflow:ApprovalPolicy:NoApproversResolved',
      DuplicateOpenRequest: 'Nexo:Workflow:ApprovalPolicy:DuplicateOpenRequest',
      StepMissingApprover: 'Nexo:Workflow:ApprovalPolicy:StepMissingApprover',
      StepMissingPermission: 'Nexo:Workflow:ApprovalPolicy:StepMissingPermission',
      StepMissingQuorumCount: 'Nexo:Workflow:ApprovalPolicy:StepMissingQuorumCount',
      UnsupportedAssignmentStrategy: 'Nexo:Workflow:ApprovalPolicy:UnsupportedAssignmentStrategy',
      PolicyEntityTypeMismatch: 'Nexo:Workflow:ApprovalPolicy:PolicyEntityTypeMismatch',
    },
    ApprovalRequest: {
      InvalidStateTransition: 'Nexo:Workflow:ApprovalRequest:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Workflow:ApprovalRequest:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Workflow:ApprovalRequest:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Workflow:ApprovalRequest:RuleExecutionFailed',
      NotFound: 'Nexo:Workflow:ApprovalRequest:NotFound',
      ConcurrencyConflict: 'Nexo:Workflow:ApprovalRequest:ConcurrencyConflict',
      DuplicateRequestNumber: 'Nexo:Workflow:ApprovalRequest:DuplicateRequestNumber',
    },
  },
  Core: {
    AssignmentPolicy: {
      NotFound: 'Nexo:Core:AssignmentPolicy:NotFound',
      ConcurrencyConflict: 'Nexo:Core:AssignmentPolicy:ConcurrencyConflict',
    },
    BatchJob: {
      NotFound: 'Nexo:Core:BatchJob:NotFound',
      ConcurrencyConflict: 'Nexo:Core:BatchJob:ConcurrencyConflict',
    },
    BatchJobRun: {
      NotFound: 'Nexo:Core:BatchJobRun:NotFound',
      ConcurrencyConflict: 'Nexo:Core:BatchJobRun:ConcurrencyConflict',
    },
    BusinessRule: {
      InvalidStateTransition: 'Nexo:Core:BusinessRule:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Core:BusinessRule:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Core:BusinessRule:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Core:BusinessRule:RuleExecutionFailed',
      NotFound: 'Nexo:Core:BusinessRule:NotFound',
      ConcurrencyConflict: 'Nexo:Core:BusinessRule:ConcurrencyConflict',
      DuplicateRuleNumber: 'Nexo:Core:BusinessRule:DuplicateRuleNumber',
    },
    CompanyProfile: {
      NotFound: 'Nexo:Core:CompanyProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Core:CompanyProfile:ConcurrencyConflict',
      DuplicateOrgUnitId: 'Nexo:Core:CompanyProfile:DuplicateOrgUnitId',
    },
    Country: {
      NotFound: 'Nexo:Core:Country:NotFound',
      ConcurrencyConflict: 'Nexo:Core:Country:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:Country:DuplicateCode',
      DuplicateAlpha3Code: 'Nexo:Core:Country:DuplicateAlpha3Code',
    },
    Currency: {
      NotFound: 'Nexo:Core:Currency:NotFound',
      ConcurrencyConflict: 'Nexo:Core:Currency:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:Currency:DuplicateCode',
    },
    DeliveryTerms: {
      NotFound: 'Nexo:Core:DeliveryTerms:NotFound',
      ConcurrencyConflict: 'Nexo:Core:DeliveryTerms:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:DeliveryTerms:DuplicateCode',
    },
    DocumentPageSetup: {
      NotFound: 'Nexo:Core:DocumentPageSetup:NotFound',
      ConcurrencyConflict: 'Nexo:Core:DocumentPageSetup:ConcurrencyConflict',
    },
    DocumentTemplate: {
      NotFound: 'Nexo:Core:DocumentTemplate:NotFound',
      ConcurrencyConflict: 'Nexo:Core:DocumentTemplate:ConcurrencyConflict',
      NotSelectable: 'Nexo:Core:DocumentTemplate:NotSelectable',
    },
    EntityTemplate: {
      NotFound: 'Nexo:Core:EntityTemplate:NotFound',
      ConcurrencyConflict: 'Nexo:Core:EntityTemplate:ConcurrencyConflict',
      VisibilityNotAllowed: 'Nexo:Core:EntityTemplate:VisibilityNotAllowed',
    },
    EnumValue: {
      NotFound: 'Nexo:Core:EnumValue:NotFound',
      ConcurrencyConflict: 'Nexo:Core:EnumValue:ConcurrencyConflict',
    },
    FieldRestrictionSet: {
      NotFound: 'Nexo:Core:FieldRestrictionSet:NotFound',
      ConcurrencyConflict: 'Nexo:Core:FieldRestrictionSet:ConcurrencyConflict',
    },
    NumberSeries: {
      NotFound: 'Nexo:Core:NumberSeries:NotFound',
      ConcurrencyConflict: 'Nexo:Core:NumberSeries:ConcurrencyConflict',
    },
    OrgRoleFunction: {
      NotFound: 'Nexo:Core:OrgRoleFunction:NotFound',
      ConcurrencyConflict: 'Nexo:Core:OrgRoleFunction:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:OrgRoleFunction:DuplicateCode',
    },
    OrgUnit: {
      NotFound: 'Nexo:Core:OrgUnit:NotFound',
      ConcurrencyConflict: 'Nexo:Core:OrgUnit:ConcurrencyConflict',
      CycleDetected: 'Nexo:Core:OrgUnit:CycleDetected',
      HasChildrenCannotDelete: 'Nexo:Core:OrgUnit:HasChildrenCannotDelete',
      MemberInvalidValidityRange: 'Nexo:Core:OrgUnit:MemberInvalidValidityRange',
      InUseCannotDelete: 'Nexo:Core:OrgUnit:InUseCannotDelete',
      DuplicateCode: 'Nexo:Core:OrgUnit:DuplicateCode',
    },
    OwnerDerivationRule: {
      NotFound: 'Nexo:Core:OwnerDerivationRule:NotFound',
      ConcurrencyConflict: 'Nexo:Core:OwnerDerivationRule:ConcurrencyConflict',
    },
    PaymentTerms: {
      NotFound: 'Nexo:Core:PaymentTerms:NotFound',
      ConcurrencyConflict: 'Nexo:Core:PaymentTerms:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:PaymentTerms:DuplicateCode',
    },
    SetupPackage: {
      NotFound: 'Nexo:Core:SetupPackage:NotFound',
      ConcurrencyConflict: 'Nexo:Core:SetupPackage:ConcurrencyConflict',
      BuilderNotFound: 'Nexo:Core:SetupPackage:BuilderNotFound',
      PackageIsEmpty: 'Nexo:Core:SetupPackage:PackageIsEmpty',
      UnsupportedSchemaVersion: 'Nexo:Core:SetupPackage:UnsupportedSchemaVersion',
      IntegrityCheckFailed: 'Nexo:Core:SetupPackage:IntegrityCheckFailed',
      UnresolvableReference: 'Nexo:Core:SetupPackage:UnresolvableReference',
    },
    TradeType: {
      NotFound: 'Nexo:Core:TradeType:NotFound',
      ConcurrencyConflict: 'Nexo:Core:TradeType:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:TradeType:DuplicateCode',
    },
    UnitOfMeasure: {
      NotFound: 'Nexo:Core:UnitOfMeasure:NotFound',
      ConcurrencyConflict: 'Nexo:Core:UnitOfMeasure:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Core:UnitOfMeasure:DuplicateCode',
    },
  },
  Sales: {
    Customer: {
      NotFound: 'Nexo:Sales:Customer:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:Customer:ConcurrencyConflict',
      DuplicateCustomerNumber: 'Nexo:Sales:Customer:DuplicateCustomerNumber',
    },
    CustomerGroup: {
      NotFound: 'Nexo:Sales:CustomerGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:CustomerGroup:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Sales:CustomerGroup:DuplicateCode',
    },
    Invoice: {
      InvalidStateTransition: 'Nexo:Sales:Invoice:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Sales:Invoice:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Sales:Invoice:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Sales:Invoice:RuleExecutionFailed',
      NotFound: 'Nexo:Sales:Invoice:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:Invoice:ConcurrencyConflict',
      DuplicateInvoiceNumber: 'Nexo:Sales:Invoice:DuplicateInvoiceNumber',
    },
    Order: {
      InvalidStateTransition: 'Nexo:Sales:Order:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Sales:Order:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Sales:Order:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Sales:Order:RuleExecutionFailed',
      NotFound: 'Nexo:Sales:Order:NotFound',
      ConcurrencyConflict: 'Nexo:Sales:Order:ConcurrencyConflict',
      CommercialTermsFrozenAfterConfirmation: 'Nexo:Sales:Order:CommercialTermsFrozenAfterConfirmation',
      DeliveryDateCannotMoveEarlier: 'Nexo:Sales:Order:DeliveryDateCannotMoveEarlier',
      DuplicateOrderNumber: 'Nexo:Sales:Order:DuplicateOrderNumber',
    },
  },
  Integration: {
    ImportProfile: {
      NotFound: 'Nexo:Integration:ImportProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:ImportProfile:ConcurrencyConflict',
    },
    IntegrationClient: {
      NotFound: 'Nexo:Integration:IntegrationClient:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationClient:ConcurrencyConflict',
    },
    IntegrationConnection: {
      NotFound: 'Nexo:Integration:IntegrationConnection:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationConnection:ConcurrencyConflict',
    },
    IntegrationJob: {
      NotFound: 'Nexo:Integration:IntegrationJob:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationJob:ConcurrencyConflict',
      DuplicateInboundMessageType: 'Nexo:Integration:IntegrationJob:DuplicateInboundMessageType',
    },
    IntegrationOutboxRecord: {
      NotFound: 'Nexo:Integration:IntegrationOutboxRecord:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationOutboxRecord:ConcurrencyConflict',
      RetryBlockedByDeliveryInFlight: 'Nexo:Integration:IntegrationOutboxRecord:RetryBlockedByDeliveryInFlight',
      DownloadRequiresProducedFile: 'Nexo:Integration:IntegrationOutboxRecord:DownloadRequiresProducedFile',
    },
    IntegrationRun: {
      NotFound: 'Nexo:Integration:IntegrationRun:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationRun:ConcurrencyConflict',
    },
    IntegrationStagingRecord: {
      NotFound: 'Nexo:Integration:IntegrationStagingRecord:NotFound',
      ConcurrencyConflict: 'Nexo:Integration:IntegrationStagingRecord:ConcurrencyConflict',
    },
  },
  Pricing: {
    InternalPriceList: {
      NotFound: 'Nexo:Pricing:InternalPriceList:NotFound',
      ConcurrencyConflict: 'Nexo:Pricing:InternalPriceList:ConcurrencyConflict',
      InvalidValidityPeriod: 'Nexo:Pricing:InternalPriceList:InvalidValidityPeriod',
      DuplicateLine: 'Nexo:Pricing:InternalPriceList:DuplicateLine',
      DuplicateCode: 'Nexo:Pricing:InternalPriceList:DuplicateCode',
    },
    PriceList: {
      InvalidStateTransition: 'Nexo:Pricing:PriceList:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Pricing:PriceList:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Pricing:PriceList:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Pricing:PriceList:RuleExecutionFailed',
      NotFound: 'Nexo:Pricing:PriceList:NotFound',
      ConcurrencyConflict: 'Nexo:Pricing:PriceList:ConcurrencyConflict',
      DuplicatePriceListCode: 'Nexo:Pricing:PriceList:DuplicatePriceListCode',
    },
  },
  Inventory: {
    InventoryPeriodClose: {
      NotFound: 'Nexo:Inventory:InventoryPeriodClose:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryPeriodClose:ConcurrencyConflict',
    },
    InventoryPostingProfile: {
      NotFound: 'Nexo:Inventory:InventoryPostingProfile:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryPostingProfile:ConcurrencyConflict',
    },
    InventoryReservation: {
      NotFound: 'Nexo:Inventory:InventoryReservation:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryReservation:ConcurrencyConflict',
    },
    InventoryTransaction: {
      InvalidStateTransition: 'Nexo:Inventory:InventoryTransaction:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Inventory:InventoryTransaction:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Inventory:InventoryTransaction:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Inventory:InventoryTransaction:RuleExecutionFailed',
      NotFound: 'Nexo:Inventory:InventoryTransaction:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:InventoryTransaction:ConcurrencyConflict',
    },
    Product: {
      NotFound: 'Nexo:Inventory:Product:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:Product:ConcurrencyConflict',
      DuplicateProductNumber: 'Nexo:Inventory:Product:DuplicateProductNumber',
    },
    ProductGroup: {
      NotFound: 'Nexo:Inventory:ProductGroup:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:ProductGroup:ConcurrencyConflict',
      DuplicateCode: 'Nexo:Inventory:ProductGroup:DuplicateCode',
    },
    StandardCostVersion: {
      InvalidStateTransition: 'Nexo:Inventory:StandardCostVersion:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:Inventory:StandardCostVersion:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:Inventory:StandardCostVersion:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:Inventory:StandardCostVersion:RuleExecutionFailed',
      NotFound: 'Nexo:Inventory:StandardCostVersion:NotFound',
      ConcurrencyConflict: 'Nexo:Inventory:StandardCostVersion:ConcurrencyConflict',
    },
  },
  TaskManagement: {
    WorkTask: {
      InvalidStateTransition: 'Nexo:TaskManagement:WorkTask:InvalidStateTransition',
      MissingRequiredFields: 'Nexo:TaskManagement:WorkTask:MissingRequiredFields',
      RuleValidationFailed: 'Nexo:TaskManagement:WorkTask:RuleValidationFailed',
      RuleExecutionFailed: 'Nexo:TaskManagement:WorkTask:RuleExecutionFailed',
      NotFound: 'Nexo:TaskManagement:WorkTask:NotFound',
      ConcurrencyConflict: 'Nexo:TaskManagement:WorkTask:ConcurrencyConflict',
    },
  },
} as const;

/** Default user-facing messages (fallback when backend message is empty) */
export const ErrorMessages: Record<string, string> = {
  'Nexo:Finance:Account:NotFound': 'Account not found',
  'Nexo:Finance:Account:ConcurrencyConflict': 'Account was modified by another user. Please refresh and try again',
  'Nexo:Finance:Account:DuplicateAccountNumber': 'A Account with the same account number already exists.',
  'Nexo:Finance:AccountDerivationRule:NotFound': 'AccountDerivationRule not found',
  'Nexo:Finance:AccountDerivationRule:ConcurrencyConflict': 'AccountDerivationRule was modified by another user. Please refresh and try again',
  'Nexo:Finance:AccountDimensionRule:NotFound': 'AccountDimensionRule not found',
  'Nexo:Finance:AccountDimensionRule:ConcurrencyConflict': 'AccountDimensionRule was modified by another user. Please refresh and try again',
  'Nexo:Finance:AccountGroup:NotFound': 'AccountGroup not found',
  'Nexo:Finance:AccountGroup:ConcurrencyConflict': 'AccountGroup was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionDefinition:NotFound': 'DimensionDefinition not found',
  'Nexo:Finance:DimensionDefinition:ConcurrencyConflict': 'DimensionDefinition was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionDefinition:DuplicateCode': 'A DimensionDefinition with the same code already exists.',
  'Nexo:Finance:DimensionDefinition:DuplicateName': 'A DimensionDefinition with the same name already exists.',
  'Nexo:Finance:DimensionSet:NotFound': 'DimensionSet not found',
  'Nexo:Finance:DimensionSet:ConcurrencyConflict': 'DimensionSet was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionSet:DuplicateHash': 'A DimensionSet with the same hash already exists.',
  'Nexo:Finance:DimensionValue:NotFound': 'DimensionValue not found',
  'Nexo:Finance:DimensionValue:ConcurrencyConflict': 'DimensionValue was modified by another user. Please refresh and try again',
  'Nexo:Finance:DimensionValue:InUseCannotDelete': 'The dimension value \'{name}\' cannot be deleted — it is still in use: {usages}. Deactivate it instead, or remove the references first.',
  'Nexo:Finance:DistributionProfile:NotFound': 'DistributionProfile not found',
  'Nexo:Finance:DistributionProfile:ConcurrencyConflict': 'DistributionProfile was modified by another user. Please refresh and try again',
  'Nexo:Finance:FiscalPeriod:InvalidStateTransition': 'Cannot transition FiscalPeriod from {currentStatus} to {targetStatus}',
  'Nexo:Finance:FiscalPeriod:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Finance:FiscalPeriod:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Finance:FiscalPeriod:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Finance:FiscalPeriod:NotFound': 'FiscalPeriod not found',
  'Nexo:Finance:FiscalPeriod:ConcurrencyConflict': 'FiscalPeriod was modified by another user. Please refresh and try again',
  'Nexo:Finance:FiscalYear:NotFound': 'FiscalYear not found',
  'Nexo:Finance:FiscalYear:ConcurrencyConflict': 'FiscalYear was modified by another user. Please refresh and try again',
  'Nexo:Finance:FiscalYear:DuplicateCode': 'A FiscalYear with the same code already exists.',
  'Nexo:Finance:PlanHeader:InvalidStateTransition': 'Cannot transition PlanHeader from {currentStatus} to {targetStatus}',
  'Nexo:Finance:PlanHeader:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Finance:PlanHeader:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Finance:PlanHeader:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Finance:PlanHeader:NotFound': 'PlanHeader not found',
  'Nexo:Finance:PlanHeader:ConcurrencyConflict': 'PlanHeader was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanHeader:ScopePinCollidesWithRowAxis': 'The dimension \'{dimension}\' cannot be pinned on this plan header: it is an entity-backed row axis of the plan view \'{planView}\', so the pin would override every row\'s value when cells are saved. Remove the pin, or choose a plan view where the dimension is not a row axis.',
  'Nexo:Finance:PlanHeader:SubmitBlockedByEmptyHeader': 'This plan header cannot be submitted: it has no plan lines. Enter at least one value before handing it in for review.',
  'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableStatus': 'This plan header is not in Draft or Returned and was skipped. Return it before re-evaluating its lines.',
  'Nexo:Finance:PlanHeader:ReevaluateRequiresEditableVersion': 'The plan version of this header is frozen or being published, so the header was skipped.',
  'Nexo:Finance:PlanHeader:ReevaluateAlreadyRunning': 'A re-evaluation is already running for this plan header, so it was skipped.',
  'Nexo:Finance:PlanHeader:ReevaluateNothingEligible': 'None of the selected plan headers can be re-evaluated: they are not in Draft or Returned, their version is frozen, or a re-evaluation is already running.',
  'Nexo:Finance:PlanHeader:EntryBlockedWhileReevaluating': 'This plan header is being re-evaluated. Entry reopens when the run completes.',
  'Nexo:Finance:PlanHeader:ReevaluateSelectionContested': 'Another re-evaluation was started for one of the selected plan headers at the same moment. Retry — headers already in a run are skipped.',
  'Nexo:Finance:PlanLine:NotFound': 'PlanLine not found',
  'Nexo:Finance:PlanLine:ConcurrencyConflict': 'PlanLine was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanLineReevaluationRun:NotFound': 'PlanLineReevaluationRun not found',
  'Nexo:Finance:PlanLineReevaluationRun:ConcurrencyConflict': 'PlanLineReevaluationRun was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanLineReevaluationRun:SystemProduced': 'Re-evaluation runs are created by the Re-evaluate lines action and cannot be created or edited by hand.',
  'Nexo:Finance:PlanLineReevaluationRun:DuplicateRunNumber': 'A PlanLineReevaluationRun with the same run number already exists.',
  'Nexo:Finance:PlanScenario:NotFound': 'PlanScenario not found',
  'Nexo:Finance:PlanScenario:ConcurrencyConflict': 'PlanScenario was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanScenario:ScenarioCodeConflict': 'A plan scenario with this code already exists in the legal entity.',
  'Nexo:Finance:PlanScenario:SourceScenarioHasNoVersions': 'The source scenario has no versions to copy the structure from.',
  'Nexo:Finance:PlanScenario:SourceVersionNotInScenario': 'The selected source version does not belong to the source scenario.',
  'Nexo:Finance:PlanScenario:InvalidScenarioType': 'The scenario type is not recognized.',
  'Nexo:Finance:PlanScenario:TargetFiscalYearNotFound': 'The selected fiscal year does not exist.',
  'Nexo:Finance:PlanStatementTemplate:NotFound': 'PlanStatementTemplate not found',
  'Nexo:Finance:PlanStatementTemplate:ConcurrencyConflict': 'PlanStatementTemplate was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanVersion:InvalidStateTransition': 'Cannot transition PlanVersion from {currentStatus} to {targetStatus}',
  'Nexo:Finance:PlanVersion:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Finance:PlanVersion:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Finance:PlanVersion:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Finance:PlanVersion:NotFound': 'PlanVersion not found',
  'Nexo:Finance:PlanVersion:ConcurrencyConflict': 'PlanVersion was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanVersion:BudgetPublishRequiresApprovedState': 'A budget version can only be published from the Approved state.',
  'Nexo:Finance:PlanVersion:WhatIfCannotBePublished': 'What-if scenarios are exploratory and can never be published.',
  'Nexo:Finance:PlanVersion:PublishBlockedByLockedVersion': 'A locked version exists in this scenario. Release or archive the lock before publishing.',
  'Nexo:Finance:PlanVersion:VersionNumberConflict': 'Another version was created in this scenario at the same time. Try again.',
  'Nexo:Finance:PlanVersion:PublishRequiresLines': 'The version has no plan lines to publish.',
  'Nexo:Finance:PlanVersion:PublishBlockedByPendingLines': 'The version has unresolved plan lines. Resolve or remove pending lines before publishing.',
  'Nexo:Finance:PlanVersion:PublishAlreadyInProgress': 'A publish is already in progress for this version.',
  'Nexo:Finance:PlanVersion:PublishBlockedByReevaluation': 'A plan-line re-evaluation is in progress for a header of this version. Publish when it has completed.',
  'Nexo:Finance:PlanVersion:PublishBlockedByMissingReference': 'An account or dimension set referenced by plan lines no longer exists. Re-map the affected lines before publishing.',
  'Nexo:Finance:PlanVersion:SubmitBlockedByUnsubmittedHeaders': 'Every plan header that contains lines must be submitted before the version can be handed in for review.',
  'Nexo:Finance:PlanVersion:ApprovalPending': 'An approval request is open for this version. Its outcome decides the version — approve or return it from your task inbox.',
  'Nexo:Finance:PlanVersion:SubmitRequiresBudgetScenario': 'Only a budget version is handed in for review. Forecast and what-if versions are published directly.',
  'Nexo:Finance:PlanVersionPublishRun:NotFound': 'PlanVersionPublishRun not found',
  'Nexo:Finance:PlanVersionPublishRun:ConcurrencyConflict': 'PlanVersionPublishRun was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanView:NotFound': 'PlanView not found',
  'Nexo:Finance:PlanView:ConcurrencyConflict': 'PlanView was modified by another user. Please refresh and try again',
  'Nexo:Finance:PlanView:MeasureFormulaRequiresDerivedKind': 'The measure \'{measure}\' has a formula but its kind is Input. Only a derived measure is calculated from a formula. Set the kind to Derived, or clear the formula.',
  'Nexo:Finance:PlanView:MeasureFormulaCycle': 'The measures {measures} refer to each other in a circle through their formulas, so none of them can be calculated. Break the loop by removing one of the references.',
  'Nexo:Finance:PlanView:StorageBindingNotValidForKind': 'The measure \'{measure}\' is stored as {binding}, which a {kind} measure cannot use — an entered value needs a destination the grid can write to, a calculated one needs a destination with a writer of its own. A {kind} measure can be stored as: {allowed}.',
  'Nexo:Finance:VatCode:NotFound': 'VatCode not found',
  'Nexo:Finance:VatCode:ConcurrencyConflict': 'VatCode was modified by another user. Please refresh and try again',
  'Nexo:Finance:VatCode:DuplicateCode': 'A VatCode with the same code already exists.',
  'Nexo:Procurement:Agreement:InvalidStateTransition': 'Cannot transition Agreement from {currentStatus} to {targetStatus}',
  'Nexo:Procurement:Agreement:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Procurement:Agreement:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Procurement:Agreement:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Procurement:Agreement:NotFound': 'Agreement not found',
  'Nexo:Procurement:Agreement:ConcurrencyConflict': 'Agreement was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Agreement:DuplicateAgreementNumber': 'A Agreement with the same agreement no. already exists.',
  'Nexo:Procurement:InboundMeasuringTicket:NotFound': 'InboundMeasuringTicket not found',
  'Nexo:Procurement:InboundMeasuringTicket:ConcurrencyConflict': 'InboundMeasuringTicket was modified by another user. Please refresh and try again',
  'Nexo:Procurement:InboundMeasuringTicket:AlreadyReceived': 'Measuring ticket {measuringTicketNumber} has already been received.',
  'Nexo:Procurement:LoadObservation:NotFound': 'LoadObservation not found',
  'Nexo:Procurement:LoadObservation:ConcurrencyConflict': 'LoadObservation was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Organization:NotFound': 'Organization not found',
  'Nexo:Procurement:Organization:ConcurrencyConflict': 'Organization was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Organization:DuplicateOrganizationCode': 'A Organization with the same organization code already exists.',
  'Nexo:Procurement:Project:NotFound': 'Project not found',
  'Nexo:Procurement:Project:ConcurrencyConflict': 'Project was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Project:DuplicateProjectId': 'A Project with the same project id already exists.',
  'Nexo:Procurement:Supplier:NotFound': 'Supplier not found',
  'Nexo:Procurement:Supplier:ConcurrencyConflict': 'Supplier was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Supplier:MultiplePrimaryBankAccounts': 'Only one bank account can be marked as primary.',
  'Nexo:Procurement:Supplier:DuplicateSupplierNumber': 'A Supplier with the same supplier no. already exists.',
  'Nexo:Procurement:Workorder:NotFound': 'Workorder not found',
  'Nexo:Procurement:Workorder:ConcurrencyConflict': 'Workorder was modified by another user. Please refresh and try again',
  'Nexo:Procurement:Workorder:DuplicateWorkorderNumber': 'A Workorder with the same workorder no. already exists.',
  'Nexo:Procurement:Workorder:DuplicateDeliverySourceId': 'A Workorder with the same delivery source id already exists.',
  'Nexo:Workflow:ApprovalDelegation:NotFound': 'ApprovalDelegation not found',
  'Nexo:Workflow:ApprovalDelegation:ConcurrencyConflict': 'ApprovalDelegation was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalPolicy:NotFound': 'ApprovalPolicy not found',
  'Nexo:Workflow:ApprovalPolicy:ConcurrencyConflict': 'ApprovalPolicy was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalPolicy:PolicyHasNoSteps': 'This approval policy has no steps, so there is nobody to approve. Add at least one step before enabling it.',
  'Nexo:Workflow:ApprovalPolicy:NoApproversResolved': 'The approval step resolved to nobody. Check that the approver reference points at a role someone currently holds.',
  'Nexo:Workflow:ApprovalPolicy:DuplicateOpenRequest': 'An approval request is already open for this record and action.',
  'Nexo:Workflow:ApprovalPolicy:StepMissingApprover': 'Step {stepName} is set to resolve a named approver but none is chosen. Pick who approves, or change the strategy.',
  'Nexo:Workflow:ApprovalPolicy:StepMissingPermission': 'Step {stepName} approves by permission but names none. Enter the permission whose holders may approve.',
  'Nexo:Workflow:ApprovalPolicy:StepMissingQuorumCount': 'Step {stepName} needs a quorum but no number of approvals. Enter how many approvals it takes.',
  'Nexo:Workflow:ApprovalPolicy:UnsupportedAssignmentStrategy': 'Step {stepName} uses an assignment strategy this version cannot resolve. Choose Specific user, Permission, Org unit role or Manager of.',
  'Nexo:Workflow:ApprovalPolicy:PolicyEntityTypeMismatch': 'This approval policy is for {policyEntityType}, not {entityType}. Approval was not started — pick a policy for this kind of record.',
  'Nexo:Workflow:ApprovalRequest:InvalidStateTransition': 'Cannot transition ApprovalRequest from {currentStatus} to {targetStatus}',
  'Nexo:Workflow:ApprovalRequest:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Workflow:ApprovalRequest:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Workflow:ApprovalRequest:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Workflow:ApprovalRequest:NotFound': 'ApprovalRequest not found',
  'Nexo:Workflow:ApprovalRequest:ConcurrencyConflict': 'ApprovalRequest was modified by another user. Please refresh and try again',
  'Nexo:Workflow:ApprovalRequest:DuplicateRequestNumber': 'A ApprovalRequest with the same request no. already exists.',
  'Nexo:Core:AssignmentPolicy:NotFound': 'AssignmentPolicy not found',
  'Nexo:Core:AssignmentPolicy:ConcurrencyConflict': 'AssignmentPolicy was modified by another user. Please refresh and try again',
  'Nexo:Core:BatchJob:NotFound': 'BatchJob not found',
  'Nexo:Core:BatchJob:ConcurrencyConflict': 'BatchJob was modified by another user. Please refresh and try again',
  'Nexo:Core:BatchJobRun:NotFound': 'BatchJobRun not found',
  'Nexo:Core:BatchJobRun:ConcurrencyConflict': 'BatchJobRun was modified by another user. Please refresh and try again',
  'Nexo:Core:BusinessRule:InvalidStateTransition': 'Cannot transition BusinessRule from {currentStatus} to {targetStatus}',
  'Nexo:Core:BusinessRule:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Core:BusinessRule:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Core:BusinessRule:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Core:BusinessRule:NotFound': 'BusinessRule not found',
  'Nexo:Core:BusinessRule:ConcurrencyConflict': 'BusinessRule was modified by another user. Please refresh and try again',
  'Nexo:Core:BusinessRule:DuplicateRuleNumber': 'A BusinessRule with the same rule number already exists.',
  'Nexo:Core:CompanyProfile:NotFound': 'CompanyProfile not found',
  'Nexo:Core:CompanyProfile:ConcurrencyConflict': 'CompanyProfile was modified by another user. Please refresh and try again',
  'Nexo:Core:CompanyProfile:DuplicateOrgUnitId': 'A CompanyProfile with the same legal entity already exists.',
  'Nexo:Core:Country:NotFound': 'Country not found',
  'Nexo:Core:Country:ConcurrencyConflict': 'Country was modified by another user. Please refresh and try again',
  'Nexo:Core:Country:DuplicateCode': 'A Country with the same alpha-2 already exists.',
  'Nexo:Core:Country:DuplicateAlpha3Code': 'A Country with the same alpha-3 already exists.',
  'Nexo:Core:Currency:NotFound': 'Currency not found',
  'Nexo:Core:Currency:ConcurrencyConflict': 'Currency was modified by another user. Please refresh and try again',
  'Nexo:Core:Currency:DuplicateCode': 'A Currency with the same code already exists.',
  'Nexo:Core:DeliveryTerms:NotFound': 'DeliveryTerms not found',
  'Nexo:Core:DeliveryTerms:ConcurrencyConflict': 'DeliveryTerms was modified by another user. Please refresh and try again',
  'Nexo:Core:DeliveryTerms:DuplicateCode': 'A DeliveryTerms with the same code already exists.',
  'Nexo:Core:DocumentPageSetup:NotFound': 'DocumentPageSetup not found',
  'Nexo:Core:DocumentPageSetup:ConcurrencyConflict': 'DocumentPageSetup was modified by another user. Please refresh and try again',
  'Nexo:Core:DocumentTemplate:NotFound': 'DocumentTemplate not found',
  'Nexo:Core:DocumentTemplate:ConcurrencyConflict': 'DocumentTemplate was modified by another user. Please refresh and try again',
  'Nexo:Core:DocumentTemplate:NotSelectable': 'The selected template cannot be used for this document type.',
  'Nexo:Core:EntityTemplate:NotFound': 'EntityTemplate not found',
  'Nexo:Core:EntityTemplate:ConcurrencyConflict': 'EntityTemplate was modified by another user. Please refresh and try again',
  'Nexo:Core:EntityTemplate:VisibilityNotAllowed': 'This visibility level is not allowed for templates of this entity.',
  'Nexo:Core:EnumValue:NotFound': 'EnumValue not found',
  'Nexo:Core:EnumValue:ConcurrencyConflict': 'EnumValue was modified by another user. Please refresh and try again',
  'Nexo:Core:FieldRestrictionSet:NotFound': 'FieldRestrictionSet not found',
  'Nexo:Core:FieldRestrictionSet:ConcurrencyConflict': 'FieldRestrictionSet was modified by another user. Please refresh and try again',
  'Nexo:Core:NumberSeries:NotFound': 'NumberSeries not found',
  'Nexo:Core:NumberSeries:ConcurrencyConflict': 'NumberSeries was modified by another user. Please refresh and try again',
  'Nexo:Core:OrgRoleFunction:NotFound': 'OrgRoleFunction not found',
  'Nexo:Core:OrgRoleFunction:ConcurrencyConflict': 'OrgRoleFunction was modified by another user. Please refresh and try again',
  'Nexo:Core:OrgRoleFunction:DuplicateCode': 'A OrgRoleFunction with the same code already exists.',
  'Nexo:Core:OrgUnit:NotFound': 'OrgUnit not found',
  'Nexo:Core:OrgUnit:ConcurrencyConflict': 'OrgUnit was modified by another user. Please refresh and try again',
  'Nexo:Core:OrgUnit:CycleDetected': 'An org unit cannot be moved under itself or one of its own sub-units.',
  'Nexo:Core:OrgUnit:HasChildrenCannotDelete': 'The org unit \'{name}\' cannot be deleted while it has sub-units. Move or delete the sub-units first.',
  'Nexo:Core:OrgUnit:MemberInvalidValidityRange': 'Valid to must not be before Valid from — a membership with an inverted window can never grant access.',
  'Nexo:Core:OrgUnit:InUseCannotDelete': 'The org unit \'{name}\' cannot be deleted — data is still registered on it: {usages}. Remove or move that data first.',
  'Nexo:Core:OrgUnit:DuplicateCode': 'A OrgUnit with the same code already exists.',
  'Nexo:Core:OwnerDerivationRule:NotFound': 'OwnerDerivationRule not found',
  'Nexo:Core:OwnerDerivationRule:ConcurrencyConflict': 'OwnerDerivationRule was modified by another user. Please refresh and try again',
  'Nexo:Core:PaymentTerms:NotFound': 'PaymentTerms not found',
  'Nexo:Core:PaymentTerms:ConcurrencyConflict': 'PaymentTerms was modified by another user. Please refresh and try again',
  'Nexo:Core:PaymentTerms:DuplicateCode': 'A PaymentTerms with the same code already exists.',
  'Nexo:Core:SetupPackage:NotFound': 'SetupPackage not found',
  'Nexo:Core:SetupPackage:ConcurrencyConflict': 'SetupPackage was modified by another user. Please refresh and try again',
  'Nexo:Core:SetupPackage:BuilderNotFound': 'No setup-package builder exists for this record type.',
  'Nexo:Core:SetupPackage:PackageIsEmpty': 'The package has no content to export or apply.',
  'Nexo:Core:SetupPackage:UnsupportedSchemaVersion': 'The package file uses a newer format than this system understands.',
  'Nexo:Core:SetupPackage:IntegrityCheckFailed': 'The package file content does not match its integrity fingerprint.',
  'Nexo:Core:SetupPackage:UnresolvableReference': 'The setup references a {entity} record ({id}) that has no transferable key — it may have been deleted. Repair or remove the reference, then build the package again.',
  'Nexo:Core:TradeType:NotFound': 'TradeType not found',
  'Nexo:Core:TradeType:ConcurrencyConflict': 'TradeType was modified by another user. Please refresh and try again',
  'Nexo:Core:TradeType:DuplicateCode': 'A TradeType with the same code already exists.',
  'Nexo:Core:UnitOfMeasure:NotFound': 'UnitOfMeasure not found',
  'Nexo:Core:UnitOfMeasure:ConcurrencyConflict': 'UnitOfMeasure was modified by another user. Please refresh and try again',
  'Nexo:Core:UnitOfMeasure:DuplicateCode': 'A UnitOfMeasure with the same code already exists.',
  'Nexo:Sales:Customer:NotFound': 'Customer not found',
  'Nexo:Sales:Customer:ConcurrencyConflict': 'Customer was modified by another user. Please refresh and try again',
  'Nexo:Sales:Customer:DuplicateCustomerNumber': 'A Customer with the same customer no. already exists.',
  'Nexo:Sales:CustomerGroup:NotFound': 'CustomerGroup not found',
  'Nexo:Sales:CustomerGroup:ConcurrencyConflict': 'CustomerGroup was modified by another user. Please refresh and try again',
  'Nexo:Sales:CustomerGroup:DuplicateCode': 'A CustomerGroup with the same code already exists.',
  'Nexo:Sales:Invoice:InvalidStateTransition': 'Cannot transition Invoice from {currentStatus} to {targetStatus}',
  'Nexo:Sales:Invoice:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Sales:Invoice:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Sales:Invoice:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Sales:Invoice:NotFound': 'Invoice not found',
  'Nexo:Sales:Invoice:ConcurrencyConflict': 'Invoice was modified by another user. Please refresh and try again',
  'Nexo:Sales:Invoice:DuplicateInvoiceNumber': 'A Invoice with the same invoice no. already exists.',
  'Nexo:Sales:Order:InvalidStateTransition': 'Cannot transition Order from {currentStatus} to {targetStatus}',
  'Nexo:Sales:Order:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Sales:Order:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Sales:Order:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Sales:Order:NotFound': 'Order not found',
  'Nexo:Sales:Order:ConcurrencyConflict': 'Order was modified by another user. Please refresh and try again',
  'Nexo:Sales:Order:CommercialTermsFrozenAfterConfirmation': '{fieldLabel} cannot be changed after the order has been confirmed.',
  'Nexo:Sales:Order:DeliveryDateCannotMoveEarlier': 'The requested delivery date can only be moved later once the order is confirmed.',
  'Nexo:Sales:Order:DuplicateOrderNumber': 'A Order with the same order number already exists.',
  'Nexo:Integration:ImportProfile:NotFound': 'ImportProfile not found',
  'Nexo:Integration:ImportProfile:ConcurrencyConflict': 'ImportProfile was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationClient:NotFound': 'IntegrationClient not found',
  'Nexo:Integration:IntegrationClient:ConcurrencyConflict': 'IntegrationClient was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationConnection:NotFound': 'IntegrationConnection not found',
  'Nexo:Integration:IntegrationConnection:ConcurrencyConflict': 'IntegrationConnection was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationJob:NotFound': 'IntegrationJob not found',
  'Nexo:Integration:IntegrationJob:ConcurrencyConflict': 'IntegrationJob was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationJob:DuplicateInboundMessageType': 'A IntegrationJob with the same endpoint name already exists.',
  'Nexo:Integration:IntegrationOutboxRecord:NotFound': 'IntegrationOutboxRecord not found',
  'Nexo:Integration:IntegrationOutboxRecord:ConcurrencyConflict': 'IntegrationOutboxRecord was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationOutboxRecord:RetryBlockedByDeliveryInFlight': 'This record is being delivered right now. Wait for it to finish before retrying.',
  'Nexo:Integration:IntegrationOutboxRecord:DownloadRequiresProducedFile': 'This record is {status} and carries no file. Either delivery has not produced one yet, or the export was refused before anything was written.',
  'Nexo:Integration:IntegrationRun:NotFound': 'IntegrationRun not found',
  'Nexo:Integration:IntegrationRun:ConcurrencyConflict': 'IntegrationRun was modified by another user. Please refresh and try again',
  'Nexo:Integration:IntegrationStagingRecord:NotFound': 'IntegrationStagingRecord not found',
  'Nexo:Integration:IntegrationStagingRecord:ConcurrencyConflict': 'IntegrationStagingRecord was modified by another user. Please refresh and try again',
  'Nexo:Pricing:InternalPriceList:NotFound': 'InternalPriceList not found',
  'Nexo:Pricing:InternalPriceList:ConcurrencyConflict': 'InternalPriceList was modified by another user. Please refresh and try again',
  'Nexo:Pricing:InternalPriceList:InvalidValidityPeriod': 'Valid from must be on or before valid to.',
  'Nexo:Pricing:InternalPriceList:DuplicateLine': 'An identical price line already exists in this list (same organisation, supplier, trade type, product group, product and unit).',
  'Nexo:Pricing:InternalPriceList:DuplicateCode': 'A InternalPriceList with the same code already exists.',
  'Nexo:Pricing:PriceList:InvalidStateTransition': 'Cannot transition PriceList from {currentStatus} to {targetStatus}',
  'Nexo:Pricing:PriceList:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Pricing:PriceList:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Pricing:PriceList:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Pricing:PriceList:NotFound': 'PriceList not found',
  'Nexo:Pricing:PriceList:ConcurrencyConflict': 'PriceList was modified by another user. Please refresh and try again',
  'Nexo:Pricing:PriceList:DuplicatePriceListCode': 'A PriceList with the same code already exists.',
  'Nexo:Inventory:InventoryPeriodClose:NotFound': 'InventoryPeriodClose not found',
  'Nexo:Inventory:InventoryPeriodClose:ConcurrencyConflict': 'InventoryPeriodClose was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryPostingProfile:NotFound': 'InventoryPostingProfile not found',
  'Nexo:Inventory:InventoryPostingProfile:ConcurrencyConflict': 'InventoryPostingProfile was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryReservation:NotFound': 'InventoryReservation not found',
  'Nexo:Inventory:InventoryReservation:ConcurrencyConflict': 'InventoryReservation was modified by another user. Please refresh and try again',
  'Nexo:Inventory:InventoryTransaction:InvalidStateTransition': 'Cannot transition InventoryTransaction from {currentStatus} to {targetStatus}',
  'Nexo:Inventory:InventoryTransaction:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Inventory:InventoryTransaction:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Inventory:InventoryTransaction:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Inventory:InventoryTransaction:NotFound': 'InventoryTransaction not found',
  'Nexo:Inventory:InventoryTransaction:ConcurrencyConflict': 'InventoryTransaction was modified by another user. Please refresh and try again',
  'Nexo:Inventory:Product:NotFound': 'Product not found',
  'Nexo:Inventory:Product:ConcurrencyConflict': 'Product was modified by another user. Please refresh and try again',
  'Nexo:Inventory:Product:DuplicateProductNumber': 'A Product with the same product no. already exists.',
  'Nexo:Inventory:ProductGroup:NotFound': 'ProductGroup not found',
  'Nexo:Inventory:ProductGroup:ConcurrencyConflict': 'ProductGroup was modified by another user. Please refresh and try again',
  'Nexo:Inventory:ProductGroup:DuplicateCode': 'A ProductGroup with the same code already exists.',
  'Nexo:Inventory:StandardCostVersion:InvalidStateTransition': 'Cannot transition StandardCostVersion from {currentStatus} to {targetStatus}',
  'Nexo:Inventory:StandardCostVersion:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:Inventory:StandardCostVersion:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:Inventory:StandardCostVersion:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:Inventory:StandardCostVersion:NotFound': 'StandardCostVersion not found',
  'Nexo:Inventory:StandardCostVersion:ConcurrencyConflict': 'StandardCostVersion was modified by another user. Please refresh and try again',
  'Nexo:TaskManagement:WorkTask:InvalidStateTransition': 'Cannot transition WorkTask from {currentStatus} to {targetStatus}',
  'Nexo:TaskManagement:WorkTask:MissingRequiredFields': 'Required fields are missing: {fields}',
  'Nexo:TaskManagement:WorkTask:RuleValidationFailed': 'Business rule validation failed',
  'Nexo:TaskManagement:WorkTask:RuleExecutionFailed': 'An error occurred while evaluating business rules',
  'Nexo:TaskManagement:WorkTask:NotFound': 'WorkTask not found',
  'Nexo:TaskManagement:WorkTask:ConcurrencyConflict': 'WorkTask was modified by another user. Please refresh and try again',
};
